import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import Card from "../components/Card";
import RedButton from "../components/RedButton";
import BlueButton from "../components/BlueButton";
import { Eye, EyeOff } from "lucide-react";
import Swal from "sweetalert2";

export default function Account() {
  const navigate = useNavigate();

  const [profile, setProfile] = useState({
    business_name: "",
    owner_name: "",
    mobile: "",
    password: "",
  });

  const [initialProfile, setInitialProfile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const authUserString = sessionStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.id;

  // ✅ Prefill form with session data
  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("authUserData"));
    if (userData) {
      setProfile({
        business_name: userData.business_name || "",
        owner_name: userData.owner_name || "",
        mobile: userData.mobile || "",
        password: userData.password || "",
      });
      setInitialProfile({
        business_name: userData.business_name || "",
        owner_name: userData.owner_name || "",
        mobile: userData.mobile || "",
        password: "",
      });
    }
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "owner_name") {
      Swal.fire({
        title: "Contact Support",
        text: "To update your Owner Name, please contact the support team.",
        icon: "info",
        confirmButtonText: "OK",
        confirmButtonColor: "#0A3E91",
      });
      return;
    }

    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Check if any change is made
  const isChanged = () => {
    if (!initialProfile) return false;
    return Object.keys(profile).some((key) => {
      if (key === "password" && profile[key] === "") return false;
      return profile[key] !== initialProfile[key];
    });
  };

  // ✅ Handle profile update
  const handleUpdateProfile = async () => {
    if (!isChanged()) {
      alert("Please update input fields to update your profile.");
      return;
    }

    try {
      const userData = JSON.parse(sessionStorage.getItem("authUserData"));
      if (!userData?.id) {
        alert("Session expired. Please login again.");
        navigate("/login");
        return;
      }

      const res = await axios.post(
        `https://goelectronix.in/api/v1/org_user/${loginUserID}`,
        {
          id: userData.id,
          ...profile,
        }
      );

      if (res.data) {
        alert("Profile updated successfully!");
        setInitialProfile(profile);
      }
    } catch (err) {
      console.error("Update failed:", err);
      alert("Failed to update profile.");
    }
  };

  // ✅ Logout
  const handleLogout = () => {
    sessionStorage.removeItem("authUserData");
    navigate("/login");
  };

  return (
    <div className="space-y-3 sm:space-y-4">
      <Header title="Account & Profile" />

      {/* Distributor Profile */}
      <Card>
        <h3 className="text-lg font-semibold text-[#0A3E91] mb-4">
          Distributor Profile
        </h3>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
          <input
            name="business_name"
            value={profile.business_name}
            onChange={handleChange}
            placeholder="Business Name"
            className="rounded-lg border px-3 py-2 text-sm"
          />
          <input
            name="owner_name"
            value={profile.owner_name}
            onChange={handleChange}
            placeholder="Owner Name"
            className="rounded-lg border px-3 py-2 text-sm"
          />
          <input
            name="mobile"
            value={profile.mobile}
            onChange={handleChange}
            placeholder="Mobile Number"
            className="rounded-lg border px-3 py-2 text-sm"
          />

          {/* Password Field */}
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={profile.password}
              onChange={handleChange}
              placeholder="Password"
              className="w-full rounded-lg border px-3 py-2 text-sm pr-10"
            />
            <button
              type="button"
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Button aligned to bottom-right */}
        <div className="mt-4 flex justify-end">
          <BlueButton onClick={handleUpdateProfile}>Update Profile</BlueButton>
        </div>
      </Card>

      {/* Session Logout */}
      <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
        <div>
          <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
            Session
          </p>
          <p className="text-xs text-slate-500">
            Manage your active session and logout.
          </p>
        </div>
        <RedButton onClick={handleLogout}>Logout</RedButton>
      </div>
    </div>
  );
}



// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";
// import { Eye, EyeOff } from "lucide-react";
// import Swal from "sweetalert2";

// export default function Account() {
//   const navigate = useNavigate();

//   const [profile, setProfile] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     password: "",
//   });

//   const [initialProfile, setInitialProfile] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;

//   // ✅ Prefill form with session data
//   useEffect(() => {
//     const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//     if (userData) {
//       setProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         password: userData.password || "",
//       });
//       setInitialProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         password: "",
//       });
//     }
//   }, []);

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "owner_name") {
//       Swal.fire({
//         title: "Contact Support",
//         text: "To update your Owner Name, please contact the support team.",
//         icon: "info",
//         confirmButtonText: "OK",
//         confirmButtonColor: "#0A3E91",
//       });
//       return;
//     }

//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   // ✅ Check if any change is made
//   const isChanged = () => {
//     if (!initialProfile) return false;
//     return Object.keys(profile).some((key) => {
//       if (key === "password" && profile[key] === "") return false;
//       return profile[key] !== initialProfile[key];
//     });
//   };

//   // ✅ Handle profile update
//   const handleUpdateProfile = async () => {
//     if (!isChanged()) {
//       alert("Please update input fields to update your profile.");
//       return;
//     }

//     try {
//       const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//       if (!userData?.id) {
//         alert("Session expired. Please login again.");
//         navigate("/login");
//         return;
//       }

//       const res = await axios.post(
//         `https://goelectronix.in/api/v1/org_user/${loginUserID}`,
//         {
//           id: userData.id,
//           ...profile,
//         }
//       );

//       if (res.data) {
//         alert("Profile updated successfully!");
//         setInitialProfile(profile);
//       }
//     } catch (err) {
//       console.error("Update failed:", err);
//       alert("Failed to update profile.");
//     }
//   };

//   // ✅ Logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData");
//     navigate("/login");
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       {/* Distributor Profile */}
//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
//           <input
//             name="business_name"
//             value={profile.business_name}
//             onChange={handleChange}
//             placeholder="Business Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="owner_name"
//             value={profile.owner_name}
//             onChange={handleChange}
//             placeholder="Owner Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="mobile"
//             value={profile.mobile}
//             onChange={handleChange}
//             placeholder="Mobile Number"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />

//           {/* Password Field */}
//           <div className="relative">
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               value={profile.password}
//               onChange={handleChange}
//               placeholder="Password"
//               className="w-full rounded-lg border px-3 py-2 text-sm pr-10"
//             />
//             <button
//               type="button"
//               className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
//               onClick={() => setShowPassword((prev) => !prev)}
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>

//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton onClick={handleUpdateProfile}>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       {/* Session Logout */}
//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }


// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";
// import { Eye, EyeOff } from "lucide-react";
// import Swal from "sweetalert2";

// export default function Account() {
//   const navigate = useNavigate();

//   const [profile, setProfile] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     gst: "",
//     pan: "",
//     pincode: "",
//     password: "",
//   });

//   const [initialProfile, setInitialProfile] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   console.log("senior id:", loginUserID);

//   // ✅ Prefill form with session data
//   useEffect(() => {
//     const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//     if (userData) {
//       setProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: userData.password,
//       });
//       setInitialProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: "",
//       });
//     }
//   }, []);

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "owner_name") {
//       Swal.fire({
//         title: "Contact Support",
//         text: "To update your Owner Name, please contact the support team.",
//         icon: "info",
//         confirmButtonText: "OK",
//         confirmButtonColor: "#0A3E91",
//       });
//       return;
//     }

//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   // ✅ Compare two objects ignoring empty password
//   const isChanged = () => {
//     if (!initialProfile) return false;
//     return Object.keys(profile).some((key) => {
//       if (key === "password" && profile[key] === "") return false;
//       return profile[key] !== initialProfile[key];
//     });
//   };

//   // ✅ Handle profile update
//   const handleUpdateProfile = async () => {
//     if (!isChanged()) {
//       alert("Please update input fields to update your profile.");
//       return;
//     }

//     try {
//       const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//       if (!userData?.id) {
//         alert("Session expired. Please login again.");
//         navigate("/login");
//         return;
//       }

//       const res = await axios.post(
//         `https://goelectronix.in/api/v1/org_user/${loginUserID}`,
//         {
//           id: userData.id,
//           ...profile,
//         }
//       );

//       if (res.data) {
//         alert("Profile updated successfully!");
//         setInitialProfile(profile);
//       }
//     } catch (err) {
//       console.error("Update failed:", err);
//       alert("Failed to update profile.");
//     }
//   };

//   // ✅ Logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData");
//     navigate("/login");
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       {/* Distributor Profile */}
//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             name="business_name"
//             value={profile.business_name}
//             onChange={handleChange}
//             placeholder="Business Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="owner_name"
//             value={profile.owner_name}
//             onChange={handleChange}
//             placeholder="Owner Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//             // readOnly // ✅ visually disable editing
//           />
//           <input
//             name="mobile"
//             value={profile.mobile}
//             onChange={handleChange}
//             placeholder="Mobile"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="gst"
//             value={profile.gst}
//             onChange={handleChange}
//             placeholder="GST"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pan"
//             value={profile.pan}
//             onChange={handleChange}
//             placeholder="PAN"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pincode"
//             value={profile.pincode}
//             onChange={handleChange}
//             placeholder="Pincode"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <div className="relative">
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               value={profile.password}
//               onChange={handleChange}
//               placeholder="Password"
//               className="w-full rounded-lg border px-3 py-2 text-sm pr-10"
//             />
//             <button
//               type="button"
//               className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
//               onClick={() => setShowPassword((prev) => !prev)}
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>

//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton onClick={handleUpdateProfile}>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       {/* Session Logout */}
//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }


// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";
// import { Eye, EyeOff } from "lucide-react";

// export default function Account() {
//   const navigate = useNavigate();

//   const [profile, setProfile] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     gst: "",
//     pan: "",
//     pincode: "",
//     password: "",
//   });

//   const [initialProfile, setInitialProfile] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false); // ✅ new loading state

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;

//   // ✅ Prefill form with session data
//   useEffect(() => {
//     const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//     if (userData) {
//       setProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: userData.password,
//       });
//       setInitialProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: "",
//       });
//     }
//   }, []);

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   // ✅ Compare two objects ignoring empty password
//   const isChanged = () => {
//     if (!initialProfile) return false;
//     return Object.keys(profile).some((key) => {
//       if (key === "password" && profile[key] === "") return false;
//       return profile[key] !== initialProfile[key];
//     });
//   };

//   // ✅ Fetch latest profile from API after update
//   const fetchUpdatedProfile = async () => {
//     try {
//       const res = await axios.get(
//         `https://goelectronix.in/api/v1/org_user/${loginUserID}`
//       );
//       if (res.data) {
//         const updatedData = res.data;

//         setProfile({
//           business_name: updatedData.business_name || "",
//           owner_name: updatedData.owner_name || "",
//           mobile: updatedData.mobile || "",
//           gst: updatedData.gst || "",
//           pan: updatedData.pan || "",
//           pincode: updatedData.pincode || "",
//           password: "",
//         });

//         setInitialProfile({
//           business_name: updatedData.business_name || "",
//           owner_name: updatedData.owner_name || "",
//           mobile: updatedData.mobile || "",
//           gst: updatedData.gst || "",
//           pan: updatedData.pan || "",
//           pincode: updatedData.pincode || "",
//           password: "",
//         });

//         // ✅ update session storage
//         sessionStorage.setItem("authUserData", JSON.stringify(updatedData));
//       }
//     } catch (err) {
//       console.error("Failed to fetch updated profile:", err);
//     }
//   };

//   // ✅ Handle profile update
//   const handleUpdateProfile = async () => {
//     if (!isChanged()) {
//       alert("Please update input fields to update your profile.");
//       return;
//     }

//     try {
//       const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//       if (!userData?.id) {
//         alert("Session expired. Please login again.");
//         navigate("/login");
//         return;
//       }

//       setLoading(true); // start loading
//       const res = await axios.post(
//         `https://goelectronix.in/api/v1/org_user/${loginUserID}`,
//         {
//           id: userData.id,
//           ...profile,
//         }
//       );

//       if (res.data) {
//         alert("Profile updated successfully!");
//         await fetchUpdatedProfile(); // 🔥 refresh UI + session
//       }
//     } catch (err) {
//       console.error("Update failed:", err);
//       alert("Failed to update profile.");
//     } finally {
//       setLoading(false); // stop loading
//     }
//   };

//   // ✅ Logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData");
//     navigate("/login");
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       {/* Distributor Profile */}
//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             name="business_name"
//             value={profile.business_name}
//             onChange={handleChange}
//             placeholder="Business Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="owner_name"
//             value={profile.owner_name}
//             onChange={handleChange}
//             placeholder="Owner Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="mobile"
//             value={profile.mobile}
//             onChange={handleChange}
//             placeholder="Mobile"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="gst"
//             value={profile.gst}
//             onChange={handleChange}
//             placeholder="GST"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pan"
//             value={profile.pan}
//             onChange={handleChange}
//             placeholder="PAN"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pincode"
//             value={profile.pincode}
//             onChange={handleChange}
//             placeholder="Pincode"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <div className="relative">
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               value={profile.password}
//               onChange={handleChange}
//               placeholder="Password"
//               className="w-full rounded-lg border px-3 py-2 text-sm pr-10"
//             />
//             <button
//               type="button"
//               className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
//               onClick={() => setShowPassword((prev) => !prev)}
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>

//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton onClick={handleUpdateProfile} disabled={loading}>
//               {loading ? "Updating your profile..." : "Update Profile"}
//             </BlueButton>
//           </div>
//         </div>
//       </Card>

//       {/* Session Logout */}
//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }


// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";
// import { Eye, EyeOff } from "lucide-react"; 

// export default function Account() {
//   const navigate = useNavigate();

//   // ✅ State for form inputs
//   const [profile, setProfile] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     gst: "",
//     pan: "",
//     pincode: "",
//     password: "",
//   });

//   const [initialProfile, setInitialProfile] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   console.log("senior id:", loginUserID);

//   // ✅ Prefill form with session data
//   useEffect(() => {
//     const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//     if (userData) {
//       setProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: userData.password, // leave blank
//       });
//       setInitialProfile({
//         business_name: userData.business_name || "",
//         owner_name: userData.owner_name || "",
//         mobile: userData.mobile || "",
//         gst: userData.gst || "",
//         pan: userData.pan || "",
//         pincode: userData.pincode || "",
//         password: "", // ignore password comparison
//       });
//     }
//   }, []);

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   // ✅ Compare two objects ignoring empty password
//   const isChanged = () => {
//     if (!initialProfile) return false;
//     return Object.keys(profile).some((key) => {
//       if (key === "password" && profile[key] === "") return false;
//       return profile[key] !== initialProfile[key];
//     });
//   };

//   // ✅ Handle profile update
//   const handleUpdateProfile = async () => {
//     if (!isChanged()) {
//       alert("Please update input fields to update your profile.");
//       return;
//     }

//     try {
//       const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//       if (!userData?.id) {
//         alert("Session expired. Please login again.");
//         navigate("/login");
//         return;
//       }

//       const res = await axios.post(
//         `https://goelectronix.in/api/v1/org_user/${loginUserID}`,
//         {
//           id: userData.id, // ✅ session user id
//           ...profile,
//         }
//       );

//       if (res.data) {
//         alert("Profile updated successfully!");
//         // update initial profile after saving
//         setInitialProfile(profile);
//       }
//     } catch (err) {
//       console.error("Update failed:", err);
//       alert("Failed to update profile.");
//     }
//   };

//   // ✅ Logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData");
//     navigate("/login");
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       {/* Distributor Profile */}
//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             name="business_name"
//             value={profile.business_name}
//             onChange={handleChange}
//             placeholder="Business Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="owner_name"
//             value={profile.owner_name}
//             onChange={handleChange}
//             placeholder="Owner Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="mobile"
//             value={profile.mobile}
//             onChange={handleChange}
//             placeholder="Mobile"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="gst"
//             value={profile.gst}
//             onChange={handleChange}
//             placeholder="GST"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pan"
//             value={profile.pan}
//             onChange={handleChange}
//             placeholder="PAN"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pincode"
//             value={profile.pincode}
//             onChange={handleChange}
//             placeholder="Pincode"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <div className="relative">
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               value={profile.password}
//               onChange={handleChange}
//               placeholder="Password"
//               className="w-full rounded-lg border px-3 py-2 text-sm pr-10"
//             />
//             <button
//               type="button"
//               className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
//               onClick={() => setShowPassword((prev) => !prev)}
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>

//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton onClick={handleUpdateProfile}>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       {/* Change Password Section */}
//       {/* <Card title="Change Password">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             type="password"
//             placeholder="Current Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="Confirm New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <BlueButton className="sm:col-span-3">Update Password</BlueButton>
//         </div>
//       </Card> */}

//       {/* Session Logout */}
//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }



// import { useNavigate } from "react-router-dom";
// import { useState } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";

// export default function Account() {
//   const navigate = useNavigate();

//   // ✅ State for form inputs
//   const [profile, setProfile] = useState({
//     business_name: "",
//     owner_name: "",
//     mobile: "",
//     gst: "",
//     pan: "",
//     pincode: "",
//     password: "",
//   });

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   // ✅ Handle profile update
//   const handleUpdateProfile = async () => {
//     try {
//       const userData = JSON.parse(sessionStorage.getItem("authUserData"));
//       if (!userData?.id) {
//         alert("Session expired. Please login again.");
//         navigate("/login");
//         return;
//       }

//       const res = await axios.post(
//         "https://goelectronix.in/api/v1/org_user/idfromsession",
//         {
//           id: userData.id, // ✅ send session user id
//           ...profile,      // ✅ send form values
//         }
//       );

//       if (res.data) {
//         alert("Profile updated successfully!");
//       }
//     } catch (err) {
//       console.error("Update failed:", err);
//       alert("Failed to update profile.");
//     }
//   };

//   // ✅ Logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData");
//     navigate("/login");
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       {/* Distributor Profile */}
//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             name="business_name"
//             value={profile.business_name}
//             onChange={handleChange}
//             placeholder="Business Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="owner_name"
//             value={profile.owner_name}
//             onChange={handleChange}
//             placeholder="Owner Name"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="mobile"
//             value={profile.mobile}
//             onChange={handleChange}
//             placeholder="Mobile"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="gst"
//             value={profile.gst}
//             onChange={handleChange}
//             placeholder="GST"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pan"
//             value={profile.pan}
//             onChange={handleChange}
//             placeholder="PAN"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             name="pincode"
//             value={profile.pincode}
//             onChange={handleChange}
//             placeholder="Pincode"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             name="password"
//             value={profile.password}
//             onChange={handleChange}
//             placeholder="Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />

//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton onClick={handleUpdateProfile}>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       {/* Change Password (separate flow if needed) */}
//       <Card title="Change Password">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             type="password"
//             placeholder="Current Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="Confirm New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <BlueButton className="sm:col-span-3">Update Password</BlueButton>
//         </div>
//       </Card>

//       {/* Session Logout */}
//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }


// import { useNavigate } from "react-router-dom";
// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";

// export default function Account() {
//   const navigate = useNavigate();

//   // ✅ handle logout
//   const handleLogout = () => {
//     sessionStorage.removeItem("authUserData"); // clear session
//     navigate("/login"); // redirect to login
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             defaultValue="Goelectronix Distributor"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             defaultValue="DST-00042"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             defaultValue="Maharashtra Central"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             defaultValue="+91 90000 00000"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             defaultValue="distributor@example.com"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             defaultValue="GSTIN/Other"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       <Card title="Change Password">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input
//             type="password"
//             placeholder="Current Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <input
//             type="password"
//             placeholder="Confirm New Password"
//             className="rounded-lg border px-3 py-2 text-sm"
//           />
//           <BlueButton className="sm:col-span-3">Update Password</BlueButton>
//         </div>
//       </Card>

//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>
//             Session
//           </p>
//           <p className="text-xs text-slate-500">
//             Manage your active session and logout.
//           </p>
//         </div>
//         {/* ✅ Logout button now clears session */}
//         <RedButton onClick={handleLogout}>Logout</RedButton>
//       </div>
//     </div>
//   );
// }


// ********************** 25 SEPT 2925 ORIGINAL CODE PHASE 1 ***********************************

// import Header from "../components/Header";
// import Card from "../components/Card";
// import RedButton from "../components/RedButton";
// import BlueButton from "../components/BlueButton";

// export default function Account() {
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Account & Profile" />

//       <Card title="Distributor Profile">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input defaultValue="Goelectronix Distributor" className="rounded-lg border px-3 py-2 text-sm" />
//           <input defaultValue="DST-00042" className="rounded-lg border px-3 py-2 text-sm" />
//           <input defaultValue="Maharashtra Central" className="rounded-lg border px-3 py-2 text-sm" />
//           <input defaultValue="+91 90000 00000" className="rounded-lg border px-3 py-2 text-sm" />
//           <input defaultValue="distributor@example.com" className="rounded-lg border px-3 py-2 text-sm" />
//           <input defaultValue="GSTIN/Other" className="rounded-lg border px-3 py-2 text-sm" />
//           <div className="sm:col-span-3 flex justify-end">
//             <BlueButton>Update Profile</BlueButton>
//           </div>
//         </div>
//       </Card>

//       <Card title="Change Password">
//         <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//           <input type="password" placeholder="Current Password" className="rounded-lg border px-3 py-2 text-sm" />
//           <input type="password" placeholder="New Password" className="rounded-lg border px-3 py-2 text-sm" />
//           <input type="password" placeholder="Confirm New Password" className="rounded-lg border px-3 py-2 text-sm" />
//           <BlueButton className="sm:col-span-3">Update Password</BlueButton>
//         </div>
//       </Card>

//       <div className="flex items-center justify-between rounded-2xl border bg-white p-4 shadow-sm">
//         <div>
//           <p className="text-sm font-semibold" style={{ color: "#0A3E91" }}>Session</p>
//           <p className="text-xs text-slate-500">Manage your active session and logout.</p>
//         </div>
//         <RedButton>Logout</RedButton>
//       </div>
//     </div>
//   );
// }